export enum CustomVideoEvents {
  TIME_SKIP_FORWARD = 'timeSkipForward',
  TIME_SKIP_BACK = 'timeSkipBack',
  VIDEO_SKIP_NEXT = 'videoSkipNext',
  VIDEO_SKIP_PREVIOUS = 'videoSkipPrevious'
}
